module.exports = __webpack_public_path__ + "img/kor.dae7a1ce.svg";